/**
 * Formatters ported verbatim from the design's data.jsx `fmt` helpers, with
 * types tightened. Same output as the prototype.
 */

export const fmt = {
  date(s?: string | null): string {
    if (!s) return '';
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  },
  dateTime(s?: string | null): string {
    if (!s) return '';
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      + ' · ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  },
  cur(n?: number | null): string {
    if (n == null) return '';
    return '$' + Math.round(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  },
  curFull(n?: number | null): string {
    if (n == null) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  },
  curK(n?: number | null): string {
    if (n == null) return '';
    if (n >= 1000) return '$' + (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    return '$' + Math.round(n);
  },
  hrs(n?: number | null): string {
    if (n == null) return '';
    return n.toFixed(1);
  },
  num(n?: number | null): string {
    if (n == null) return '';
    return n.toLocaleString('en-US');
  },
  em<T>(v: T | null | undefined): T | '—' {
    return v == null || v === '' ? '—' : v;
  },
  range(a?: string | null, b?: string | null): string {
    if (!a || !b) return '';
    const da = new Date(a);
    const db = new Date(b);
    const ms = da.toLocaleDateString('en-US', { month: 'short' });
    const dbm = db.toLocaleDateString('en-US', { month: 'short' });
    const yr = db.getFullYear();
    if (da.getFullYear() === db.getFullYear()) {
      return `${ms} ${da.getDate()} – ${dbm} ${db.getDate()}, ${yr}`;
    }
    return `${ms} ${da.getDate()}, ${da.getFullYear()} – ${dbm} ${db.getDate()}, ${yr}`;
  },
};
